import {UmpirePlayer} from '../umpire-player';
import {UmpireImage} from '../umpire-image';
import {UmpireSquad} from '../umpire-squad';
import {UmpirePublicationOptions} from '../umpire-publication-options';

export class UmpireSquadPlayer implements UmpirePublicationOptions {
  type!: string;

  id!: string;

  number!: number | null;

  first_name!: string | null;

  last_name!: string | null;

  short_name!: string | null;

  position!: string | null;

  squad!: UmpireSquad;

  image!: UmpireImage;

  player!: UmpirePlayer;

  status!: string | null;

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  is_youth!: boolean;

  slug!: string | null;
}
